import React, { useEffect } from 'react'

declare global {
  interface Window {
    google?: any
  }
}

let buttonInstanceCount = 0

/**
 * Renders Google's "Sign in with Google" button via Google Identity
 * Services (loaded on demand, free, no backend involved). Used by both the
 * onboarding wizard (/get-started) and the account portal login
 * (/account/login). Renders nothing if REACT_APP_GOOGLE_CLIENT_ID isn't set.
 */
const GoogleSignInButton: React.FC<{ onToken: (idToken: string) => void }> = ({ onToken }) => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID
  const containerId = React.useMemo(() => `google-signin-btn-${buttonInstanceCount++}`, [])

  useEffect(() => {
    if (!clientId) return

    const render = () => {
      if (!window.google) return
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response: any) => onToken(response.credential),
      })
      const el = document.getElementById(containerId)
      if (el) window.google.accounts.id.renderButton(el, { theme: 'outline', size: 'large', width: 320 })
    }

    if (document.getElementById('google-identity-script')) {
      render()
      return
    }

    const script = document.createElement('script')
    script.id = 'google-identity-script'
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.onload = render
    document.body.appendChild(script)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId])

  if (!clientId) return null
  return <div id={containerId} />
}

export default GoogleSignInButton
